import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 px-0" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon mr-2 icon-vorteile_rund_um_die_uhr",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "table table-striped my-4"
}
const _hoisted_6 = { class: "thead-dark" }
const _hoisted_7 = { class: "table-width-150" }
const _hoisted_8 = { class: "table-width-150" }
const _hoisted_9 = { class: "table-width-100" }
const _hoisted_10 = { class: "table-width-150" }
const _hoisted_11 = { class: "table-width-150" }
const _hoisted_12 = { class: "table-width-100" }
const _hoisted_13 = { class: "d-flex justify-content-center aling-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_link_back = _resolveComponent("link-back")!
  const _component_link_default = _resolveComponent("link-default")!
  const _component_feedback_message = _resolveComponent("feedback-message")!
  const _component_loading_container = _resolveComponent("loading-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, [
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('views.overbooked.title')), 1)
      ])
    ]),
    _createVNode(_component_link_back, {
      to: "/",
      i18nMessage: "common.backToOverview"
    }),
    _createVNode(_component_loading_container, {
      state: _ctx.state,
      errorLinkTo: "/holiday-list"
    }, {
      default: _withCtx(() => [
        (_ctx.timeSlots.length > 0)
          ? (_openBlock(), _createElementBlock("table", _hoisted_5, [
              _createElementVNode("thead", _hoisted_6, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('views.overbooked.timeSlot')), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('views.overbooked.room')), 1),
                  _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t('views.overbooked.ticketCount')), 1),
                  _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('views.overbooked.capacity')), 1),
                  _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('views.overbooked.actions')), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeSlots, (timeSlot, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.formatTime(timeSlot)), 1),
                    _createElementVNode("td", null, _toDisplayString(timeSlot.roomName), 1),
                    _createElementVNode("td", _hoisted_10, _toDisplayString(timeSlot.ticketCount), 1),
                    _createElementVNode("td", _hoisted_11, _toDisplayString(timeSlot.capacity), 1),
                    _createElementVNode("td", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_link_default, {
                          i18nMessage: "common.timeSlotEdit",
                          to: { name: 'admin-time-slot-edit', params: { roomId: timeSlot.roomId, timeSlotId: timeSlot.id } },
                          iconOnly: true,
                          iconClass: "icon-editieren",
                          class: "align-self-center"
                        }, null, 8, ["to"])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.timeSlots.length === 0)
          ? (_openBlock(), _createBlock(_component_feedback_message, {
              key: 1,
              message: _ctx.$t('views.overbooked.noTimeSlots')
            }, null, 8, ["message"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["state"])
  ]))
}